import { 
  useEffect,
  useState, 
} from "react";

const useCheckApplicationUpdate = (interval = 60 * 1000) => {
  const [ isUpdated, setIsUpdated ] = useState(false);
  const [ lastManifest, setLastManifest ] = useState(null);

  useEffect(() => {
    if (isUpdated) {
      return ;
    }

    const intervalHandler = setInterval(async () => {
      const manifest = await (await fetch("/packs/manifest.json")).text();

      if (lastManifest !== null && manifest !== lastManifest) {
        setIsUpdated(true);
      }

      setLastManifest(manifest);
    }, interval);

    return () => {
      clearInterval(intervalHandler);
    }
  }, [interval, lastManifest]);

  return (isUpdated);
}

export default useCheckApplicationUpdate;
